import useGetTickets from "../hooks/useGetTickets";
import { PrimaryButton, LegacyText } from "flicket-ui";
import {
  PageContext,
  competitionFromPageContext,
  eventPhaseFromPageContext,
  isOnsaleCompetitionContext,
  isOnsaleContext,
  isRegistrationCompetitionContext,
  isRegistrationContext,
  isRegistrationPresaleContext,
  isRegistrationPresaleCompetitionContext,
  isRegistrationPresalePrePurchaseContext,
} from "../hooks/useDetailsPageContext";
import useCaptureClick from "~telemetry/traces/useCaptureClick";
import {
  AttributeNames,
  InteractionNames,
} from "~telemetry/enums/AttributeNames";
import { useOrganization } from "~hooks";
import { OrganizationFeatures } from "~lib";

export function getRegisterLabel(
  pageContext: PageContext,
  organizationId: string
): string {
  if (
    pageContext.state === "registration-presale" ||
    pageContext.state === "registration-presale-competition"
  ) {
    return "Register for presale notification";
  }

  if (pageContext.state === "registration-presale-pre-purchase") {
    return "Register for early access";
  }

  // ASB Classic
  if (organizationId === "c8f276b9-87d5-42c8-ba3f-102089545cde") {
    return "Join the club";
  }

  return "Register";
}

export default function MainCTA(props: { pageContext: PageContext }) {
  const { pageContext } = props;
  const { navigate, url } = useGetTickets(pageContext.event.id);
  const { organization, hasFeature } = useOrganization();

  const competitionId = competitionFromPageContext(pageContext)?.id;

  const captureClick = useCaptureClick({
    forwardToNest: true,
    eventId: pageContext.event.id,
    pageName: "event-details-page",
    attributes: {
      [AttributeNames.FLICKET_COMPETITION_ID]: competitionId,
      [AttributeNames.FLICKET_EVENT_PHASE]: eventPhaseFromPageContext(
        pageContext
      ),
    },
  });

  const registerLabel = getRegisterLabel(pageContext, organization.id);

  const handleClickBuyTickets = () => navigate();

  if (isOnsaleContext(pageContext) || isOnsaleCompetitionContext(pageContext)) {
    return (
      <PrimaryButton
        width="100%"
        href={url}
        linkProps={{
          width: "100%",
        }}
        onClick={captureClick(
          handleClickBuyTickets,
          InteractionNames.BUTTON_PRIMARY,
          {
            [AttributeNames.BUTTON_LABEL]: "Buy tickets",
          }
        )}
      >
        <LegacyText fontSize={3}>Buy tickets</LegacyText>
      </PrimaryButton>
    );
  }

  if (
    isRegistrationContext(pageContext) ||
    isRegistrationCompetitionContext(pageContext) ||
    isRegistrationPresaleCompetitionContext(pageContext) ||
    isRegistrationPresaleContext(pageContext) ||
    isRegistrationPresalePrePurchaseContext(pageContext)
  ) {
    return (
      <PrimaryButton
        width="100%"
        linkProps={{
          width: "100%",
        }}
        href={
          !hasFeature(OrganizationFeatures.PrePurchaseRegistration)
            ? `/events/${pageContext.event.id}/registration`
            : undefined
        }
        onClick={captureClick(() => {
          if (hasFeature(OrganizationFeatures.PrePurchaseRegistration)) {
            pageContext.setActiveModal("registration");
          }
        }, "register-button")}
      >
        {registerLabel}
      </PrimaryButton>
    );
  }

  return null;
}
